import { AxiosPromise } from 'axios';
import Resource, { Params } from 'src/services/api-client/resource/base/Resource';
import FilledAptitudeTest from 'src/entities/FilledAptitudeTest';

export interface FilledAptitudeTestResponse {
  aptitudeTest: FilledAptitudeTest;
}

export default class FilledAptitudeTestResource extends Resource {
  constructor() {
    super('/filled-aptitude-tests/');
  }

  public get(filledTestId: number): AxiosPromise<FilledAptitudeTestResponse> {
    this.getHeaders();

    return super.get(filledTestId);
  }

  public getLatest(params: Params): AxiosPromise<FilledAptitudeTestResponse> {
    this.getHeaders();
    const url: string = 'latest';

    return super.get(url, params);
  }

  public create(filledAptitudeTest: FilledAptitudeTest, params: Params): AxiosPromise<FilledAptitudeTestResponse> {
    this.getHeaders();

    return super.create(filledAptitudeTest, params);
  }
}



// WEBPACK FOOTER //
// ./src/services/api-client/resource/FilledAptitudeTestResource.tsx